import { createFileRoute } from '@tanstack/react-router'
import AdminAiTrainingPage from '@/spa/pages/admin/AdminAiTrainingPage'
import { routeErrorComponent } from '../_shared/RouteError'

export const Route = createFileRoute('/admin/ai-training')({
  component: AdminAiTrainingPage,
  errorComponent: routeErrorComponent,
})
